import { ArcCoordinates } from "./ArcCoordinates";

export function SVG_AddSlice(startAngle, endAngle, radius, originX, originY) {
  var largeArc = endAngle - startAngle <= Math.PI ? "0" : "1";
  var start = ArcCoordinates(originX, originY, radius, endAngle);
  var end = ArcCoordinates(originX, originY, radius, startAngle);
  var d = [
    "M",
    start.x,
    start.y,
    "A",
    radius,
    radius,
    0,
    largeArc,
    0,
    end.x,
    end.y,
    "L",
    originX,
    originY,
    "Z"
  ].join(" ");
  return d;
}
